import { Box, Card, Divider, List, ListItem, Typography } from '@mui/material'

const InformeCard = ({ data, structure = {} }) => {
  const plugin = structure.find((c) => typeof c?.customGetter === 'function')

  return (
    <Card sx={{ p: 1 }}>
      <List>
        {plugin && (
          <>
            <ListItem sx={{ justifyContent: 'flex-end', py: 0.5 }}>
              {plugin.customGetter(data)}
            </ListItem>
            <Divider component="li" />
          </>
        )}
        {structure?.map((e, i) => {
          if (e.field) {
            return (
              <>
                <ListItem>
                  <Box>
                    <Typography variant="caption">{e.title}</Typography>
                    <Typography variant="body2">{data[e.field]}</Typography>
                  </Box>
                </ListItem>
                {i < structure.length - 1 ? <Divider component="li" /> : <></>}
              </>
            )
          }
        })}
      </List>
    </Card>
  )
}

export default InformeCard
